// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"1b6481f6","222":"74bfdd92","510":"5b2c5af5","957":"ebb5a181"}[chunkId] + ".chunk.js";
};